module.exports = __webpack_public_path__ + "static/media/AlPunto_block.d74ad439.svg";